import React, { useState, useEffect } from 'react';
import { toInteger } from 'lodash';

import moment from 'moment';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

import {
    Box,
    Container,
    makeStyles,
    Card,
    CardContent
} from '@material-ui/core';

import { RiAlarmWarningFill } from "react-icons/ri";
import { AiOutlineSchedule } from "react-icons/ai";

import Page from 'src/components/Page';
import agm from '../../services/agm';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';
import Upload from '../documents/Upload';

import Document from '../occurrences/Document';
import Results from './Results';
import Toolbar from './Toolbar';
import Create from '../occurrences/Create';
import Occurrence from '../occurrences/Occurrence';
import Treatment from '../occurrences/Treatment';
import Schedule from '../occurrences/Schedule';
import Infra from '../occurrences/Infra';
import Action from '../occurrences/Action';

import MapaRota from './MapaRota';
import Print from './Print';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const defaultBase = { lat: -22.939529, lng: -43.231062 };

const defaultInfra = {
    id: null,
    nome: "",
    tipo: {},
    TIPO: null,
    valores: [],
    docs: []
}

const defaultItemNewItem = {
    company: 1,
    contract: null,
    dateAperture: new Date(),
    number: null,
    unit: null,
    code: null,
    name: '',
    type: '',
    occurrenceType: null,
    category: null,
    invoiceType: 3,
    ocorrenceStatus: 9,
    atendType: null,
    companyStatus: 1,
    symptom: null,
    dateFirstAtend: null,
    symptomLocal: null,
    dateConclusion: null,
    description: null,
    dateProtocol: null,
    tarefa: null,
    timelimcpa: null,
    timelimcpc: null,
    numbersa: null
}

var defaultItemEditItem = {
    loaded: false,
    ocorrencia: null,
    id: null,
    company: null,
    contract: null,
    dateAperture: null,
    number: null,
    unit: null,
    code: null,
    name: null,
    supervisor: null,
    controller: null,
    engineer: null,
    team: null,
    region: null,
    typeUnit: null,
    conclusionStatus: null,
    companyStatus: null,
    occurrenceType: null,
    category: null,
    invoiceType: null,
    ocorrenceStatus: null,
    atendType: null,
    statusRevenues: null,
    description: null,
    dateFirstAtend: null,
    dateConclusion: null,
    dateStarted: null,
    datefinished: null,
    timeService: null,
    kmService: null,
    symptom: null,
    symptomLocal: null,
    executed: null,
    orderDesc: null,
    planDesc: null,
    dateProtocol: null,
    lote: null,
    justify: null,
    task: null,
    taskName: null,
    budgetid: null,
    budgetnumero: null,
    budgetdataCriacao: null,
    budgetdataProtocolo: null,
    budgetdataEnvio: null,
    budgetvalorMaoObra: 0.0,
    budgetvalorMaterial: 0.0,
    budgetvalorDesconto: 0.0,
    budgetvalortotal: 0.0,
    budgetFASE_ORCAMENTO: null,
    budgetORCAMENTISTA: null,
    budgetTECNICO: null,
    budgetOCORRENCIA: null,
    budgetfoiExecutado: null,
    budgetServicoExecutar: null,
    idProduto: '',
    qtdProduto: '',
    codigoProduto: '',
    nomeProduto: '',
    lpuProduto: '',
    custoProduto: '',
    bdiProduto: '',
    valorProduto: '',
    origemProduto: '',
    aplicacaoProduto: '',
    unidadeProduto: '',
    instalacaoProduto: '',
    produto: {},
    atualizarPdf: false,
    baixarEstoque: false,
    chavePdf: null,
    expenseTotalCustos: 0.0,
    expenseTotalDespesas: 0.0,
    expenseCodigo: '',
    expenseEstoque: '',
    expenseNome: '',
    expenseTipo: 1,
    expenseNota: '',
    expenseNotaFornecedor: '',
    expenseQtd: '',
    expenseCusto: '',
    expenseValor: '',
    expenseId: '',
    timelimcpa: null,
    timelimcpc: null,
    numbersa: null,
    orderCpNome:null,
    orderCpQtd: 1,
    orderCpUnid: null,
    orderCpVlr: 0.0,
    orderCpFornec: null,
    orderCpInstruc: null,
    orderPlanNome:null,
    orderPlanQtd: 1,
    orderPlanUnid: null,
    orderPlanInstruc: null,
};

var defaultDependencies = {
    loaded: false,
    companies: [],
    contracts: [],
    occurrenceTypes: [],
    invoiceTypes: [],
    categories: [],
    ocorrenceStatusList: [],
    atendTypes: [],
    companyStatusList: [],
    symptomes: [],
    symptomLocals: [],
    revenuesStatusList: [],
    revenuesLoteList: [],
    conclusionStatusList: [],
    phases: [],
    makers: [],
    tasks: [],
    technicians: [],
    items: [],
    removes: [],
    documents: [],
    infras: [],
    equipments: [],
    actions: [],
    orders: [],
    plans: [],
    infrasUnidade: [],
    visits: [],
    expensesType: [],
    expensesProvider: [],
    expenses: [],
    applications: [],
    units: [],
    origins: [],
    region: null
};

const defaultAppointments = {
    typesTechnician: [],
    technicians: [],
    schedules: [],
    resources: [],
    veicles: []
};

const defaultState = {
    loaded: false,
    records: -1,
    pages: 0,
    page: 0,
    count: 0,
    rows: [],
    base: defaultBase,
    veicles: [],
    locations: [],
    start: new Date(),
    end: new Date()
}

const defaultUploadState = [];

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
    { name: 'Código', field: 'item.codigo', size: -1, sortable: 0, exportable: 1, wrap: 0 },
    { name: 'Unidade', field: 'item.nome', size: -1, sortable: 0, exportable: 1, wrap: 0 },
    { name: 'Ocorrências', field: 'item.ocorrencias.length', size: -1, sortable: 0, exportable: 1, wrap: 0 }
];

const defaultEmptyMessage = "Nenhuma Agendamento Foi Encontrado.";

const defaultfullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: defaultEmptyMessage,
    columns: defaultResultColumns
};

const defaultCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_HIDE,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_HIDE,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: defaultEmptyMessage,
    columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
    { id: 1, name: 'Atendimento - Número Ocorrência', refine: 1, label: 'Número', history: 0 }
];

const defaultFilter = {
    pagina: 0,
    registros: -1,
    inicio: defaultStartDateTime,
    final: defaultEndDateTime,
    palavrachave: '',
    ordenacao: 'asc',
    ordem: '',
    visao: defaultVisions[0],
    tipos: {
        corretiva: true,
        preventiva: true,
        avcb: true,
        pendencia: true
    },
    contrato: 3,
    base: defaultBase,
    regioes: [],
    equipes: [],
    cpccpa: 0,
    tecnicos: []
}

const defaultStatusRegister = {
    id: null,
    ocorrencia: null,
    usuario: null,
    justificativa: '',
    data: null,
    statusEmpresa: null
}

const defaultStatusHistory = {
    registers: [],
    actions: [],
    orders: [],
    plans: [],
    technician: null
}

const defaultBudget = {
    id: null,
    numero: null,
    dataCriacao: null,
    dataProtocolo: null,
    dataEnvio: null,
    foiExecutado: null,
    valorMaoObra: null,
    valorMaterial: null,
    FASE_ORCAMENTO: null,
    ORCAMENTISTA: null,
    TECNICO: null,
    OCORRENCIA: null,
    itens: []
}

const defaultVisit = {
    id: null,
    ocorrencia: null,
    dataAgenda: null,
    tecnico: null,
    auxiliar: null,
    prestadora: null,
    observacao: null,
    veiculo: null,
    hora: null,
    abertura: null
}

const defaultAction = {
    id: null,
    ocorrencia: null,
    data: new Date(),
    descricao: null,
    usuario: null
}

const Agendas = () => {

    const classes = useStyles();

    const [item, setItem] = useState(defaultItemEditItem);
    const [openCreationDialog, setOpenCreationDialog] = useState(false);
    const [openEditionDialog, setOpenEditionDialog] = useState(false);
    const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [filter, setFilter] = useState(defaultFilter);
    const [vision, setVision] = useState(defaultVisions[0]);
    const [resultModes, setResultModes] = useState(defaultResultModes);
    const [selectedMode, setSelectedMode] = useState(MODE_FULL);
    const [dependencies, setDependencies] = useState(defaultDependencies);
    const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [uploadState, setUploadState] = useState(defaultUploadState);
    const [openDeletionDocumentDialog, setOpenDeletionDocumentDialog] = useState(false);
    const [document, setDocument] = useState({});
    const [openDocumentEditionDialog, setOpenDocumentEditionDialog] = useState(false);

    const [statusHistory, setStatusHistory] = useState(defaultStatusHistory);
    const [appointments, setAppointments] = useState(defaultAppointments);
    const [openDeletionVisitDialog, setOpenDeletionVisitDialog] = useState(false);
    const [openVisitEditionDialog, setOpenVisitEditionDialog] = useState(false);

    const [infra, setInfra] = useState(defaultInfra);
    const [openInfraEditionDialog, setOpenInfraEditionDialog] = useState(false);
    const [infraDocument, setInfraDocument] = useState(null);

    const [infoValues, setInfoValues] = useState([]);

    const [state, setState] = useState(defaultState);

    const [visit, setVisit] = useState(defaultVisit);

    const [action, setAction] = useState(defaultAction);
    const [openDeletionActionDialog, setOpenDeletionActionDialog] = useState(false);
    const [openActionEditionDialog, setOpenActionEditionDialog] = useState(false);
    const [openMapaRotaDialog, setOpenMapaRotaDialog] = useState(false);

    const [openPrintDialog, setOpenPrintDialog] = useState(false);

    const [value, setValue] = useState(0);
    const [selecteds, setSelecteds] = useState([]);

    const createOAT = async (values) => {

        var ordem = {
            numeroot: (values.number) ? values.number : '',
            numerosa: (values.numbersa) ? values.numbersa : '',
            endereco: (values.ocorrencia) ? values.ocorrencia.unidade.endereco : '',
            cpa: (values.dateFirstAtend) ? moment(values.dateFirstAtend).format('DD/MM/YYYY') : '',
            horacpa: (values.timelimcpa) ? values.timelimcpa : '',
            cpc: (values.dateConclusion) ? moment(values.dateConclusion).format('DD/MM/YYYY') : '',
            horacpc: (values.timelimcpc) ? values.timelimcpc : '',
            descricao: (values.ocorrencia) ? values.ocorrencia.descricao : '',
            categoria: (values.ocorrencia) ? values.ocorrencia.CATEGORIA : 0,
            outro: (values.ocorrencia) ? values.ocorrencia.categoria.nome : 0,
            cliente: 'Banco Itaú S/A',
            agencia: (values.ocorrencia) ? values.ocorrencia.unidade.codigo : '',
            unidade: (values.ocorrencia) ? values.ocorrencia.unidade.nome : '',
            cidade: (values.ocorrencia) ? values.ocorrencia.unidade.municipio.nome : '',
            atendimento: '',
            tecnico: (values.ocorrencia.tecnico) ? values.ocorrencia.tecnico.nome : '',
            horainicio: '',
            horatermino: '',
            veiculo: (values.ocorrencia.veiculo) ? values.ocorrencia.veiculo : ''
        }
        await agm.post('/ocorrencias/createoat', { values: ordem }, {}).then((response) => {
            setMessage(response.data);
            setOpenAlert(true);
            const link = window.document.createElement('a');
            var url = process.env.REACT_APP_AGM_ENDPPOINT + '/reports/OAT_' + ordem.numeroot + '.pdf';
            link.setAttribute('download', 'OAT_' + ordem.numeroot + '.pdf');
            link.setAttribute('target', '_target');
            link.href = url;
            window.document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, info: true, message: 'Erro ao gerar Ordem de Atendimento. ' + error.message });
            setOpenAlert(true);
        });
    }

    const openExportDialog = async (format) => {
        if (format == 'excel') {
            await agm.post('/ocorrencias/export', { format: format, filtro: filter, colunas: defaultResultColumns }, {}).then((response) => {
                setMessage(response.data);
                setOpenAlert(true);
                const link = window.document.createElement('a');
                var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/ocorrencias.xlsx';
                link.setAttribute('download', 'ocorrencias.xlsx');
                link.href = url;
                window.document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
                setOpenAlert(true);
            });
        }

        if (format == 'zip') {
            var filename = 'Formularios_RAT.zip';
            await agm.post('/ocorrencias/rats', { filename: filename, filtro: filter }, { responseType: 'blob' }).then(async (response) => {
                if (!response.data.error) {
                    const blob = new Blob([response.data], { type: 'application/zip' });
                    const downloadUrl = URL.createObjectURL(blob);
                    const link = window.document.createElement('a');
                    link.setAttribute('download', filename);
                    link.href = downloadUrl;
                    window.document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(downloadUrl);
                    setMessage({ error: false, fatal: false, message: 'Arquivo Gerado com sucesso. ' });
                    setOpenAlert(true);
                } else {
                    setMessage(response.data);
                    setOpenAlert(true);
                }
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo. ' + error.message });
                setOpenAlert(true);
            });
        }
    }

    const openEdition = async (item) => {
        setItem(item);
        await updateProcessings(item.id);
        setOpenEditionDialog(true);
    }

    const openCreation = (item) => {
        setItem(item);
        agm.get('/ocorrencias/criacao/' + item.company, {}, {}).then((response) => {
            if (!response.data.error) {
                setDependencies(
                    {
                        loaded: true,
                        companies: response.data.listaEmpresas,
                        contracts: response.data.listaContratos,
                        occurrenceTypes: response.data.listaTiposOcorrencia,
                        invoiceTypes: response.data.listaTiposNota,
                        categories: response.data.listaCategorias,
                        ocorrenceStatusList: response.data.listaStatusOcorrencia,
                        atendTypes: response.data.listaTiposAtendimento,
                        companyStatusList: response.data.listaStatusEmpresa,
                        symptomes: response.data.listaSintomas,
                        symptomLocals: response.data.listaLocaisSintomas,
                        expensesType: [],
                        expensesProvider: [],
                        revenuesStatusList: [],
                        revenuesLoteList: [],
                        conclusionStatusList: [],
                        phases: [],
                        makers: [],
                        tasks: [],
                        technicians: [],
                        items: [],
                        removes: [],
                        documents: [],
                        infras: [],
                        equipments: [],
                        actions: [],
                        orders: [],
                        plans: [],
                        infrasUnidade: [],
                        visits: [],
                        expenses: [],
                        applications: [],
                        units: [],
                        origins: [],
                        region: null
                    }
                );
                item.dateFirstAtend = null;
                item.dateConclusion = null;
                setItem(item);
                setOpenCreationDialog(true);
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, info: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const openDeletion = (item) => {
        setItem(item);
        setMessage({
            title: 'Ocorrência',
            message: 'Deseja excluir a ocorrência selecionada?',
            warn: 'Esta ação irá remover todos os dados e os documentos associados a ocorrência ' + item.numero +
                '. Assim tanto os dados como os arquivos não poderão mais ser recuperados.'
        });
        setOpenDeletionDialog(true);
    }

    const openTreatment = async (item) => {
        setItem(item);
        await agm.post('/ocorrencias/tratamento', {
            ocorrencia: item.id,
            tecnico: (item.tecnico) ? item.tecnico.id : null,
            empresa: item.empresa
        }, {}).then((response) => {
            if (!response.data.error) {
                setStatusHistory(response.data)
                setOpenTreatmentDialog(true);
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const openActionEdition = (item) => {
        if (!item.id) {
            item = defaultAction;
        }
        setAction(item);
        setOpenActionEditionDialog(true);
    };

    const closeActionEdition = () => {
        setOpenActionEditionDialog(false);
    }

    const closeMapaRota = () => {
        setOpenMapaRotaDialog(false);
    }

    const updateActionValues = async (values) => {
        values.ocorrencia = item.id;
        values.usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        values.data = new Date();
        if (values.id != null) {
            await agm.put('/ocorrencias/action/' + values.id, values).then((response) => {
                if (!response.data.error) {
                    updateProcessings(item.id);
                    closeActionEdition();
                }
                setMessage(response.data);
                setOpenAlert(true);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })

        } else {
            await agm.post('/ocorrencias/action', values).then((response) => {
                if (!response.data.error) {
                    updateProcessings(item.id);
                    closeActionEdition();
                }
                setMessage(response.data);
                setOpenAlert(true);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })
        }
    }

    const openDeletionAction = (item) => {
        setAction(item);
        setMessage({
            title: 'Ação',
            message: 'Deseja excluir a ação selecionada?'
        });
        setOpenDeletionActionDialog(true);
    };

    const closeDeletionAction = () => {
        setOpenDeletionActionDialog(false);
    }

    const closeDeletion = () => {
        setOpenDeletionDialog(false);
    };

    const closeEdition = () => {
        setOpenEditionDialog(false);
    };

    const closeCreation = () => {
        setOpenCreationDialog(false);
    };

    const closeTreatment = () => {
        setOpenTreatmentDialog(false);
    };

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const updateTreatmentValues = async (values) => {
        values.ocorrencia = item.id;
        values.usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        values.data = new Date();
        await agm.put('/ocorrencias/tratamento/' + item.id, values).then((response) => {
            if (!response.data.error) {
                updateProcessings(values.id);
                closeTreatment();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const updateValues = async (values, save) => {
        if (!save) {
            values.user = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
            values.schedules = dependencies.visits;
            values.expenses = dependencies.expenses;
            await agm.put('/ocorrencias/execute/' + values.id, { values }).then((response) => {
                if (!response.data.error) {
                    updateProcessings(values.id);
                    values.baixarEstoque = false;
                }
                setMessage(response.data);
                setOpenAlert(true);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })
        } else {
            await agm.put('/ocorrencias/' + values.id, values).then((response) => {
                if (!response.data.error) {
                    updateProcessings(values.id);
                }
                setMessage(response.data);
                setOpenAlert(true);
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })
        }

    };

    const createValues = async (values) => {
        values.user = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        values.justification = 'Criação de ocorrência manual pelo usuário';
        await agm.post('/ocorrencias', values).then((response) => {
            if (!response.data.error) {
                refreshItems();
                closeCreation();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    };

    const deleteAction = async (values) => {
        setAction(values);
        await agm.delete('/ocorrencias/action/' + values.id).then((response) => {
            if (!response.data.error) {
                updateProcessings(values.ocorrencia);
            }
            closeDeletionAction();
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            closeDeletionAction();
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const deleteValues = (values) => {
        agm.delete('/ocorrencias/' + values.id).then((response) => {
            if (!response.data.error) {
                refreshItems();
            }
            closeDeletion();
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            closeDeletion();
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const refreshItems = () => {
        agm.post('/ocorrencias/agenda', { filtro: filter }, {}).then((response) => {
            if (!response.data.error) {
                setState({
                    loaded: true,
                    pages: toInteger((response.data.count / filter.registros)) + 1,
                    page: filter.pagina,
                    count: response.data.count,
                    rows: response.data.rows,
                    locations: response.data.posicoes,
                    veicles: response.data.veiculos,
                    base: response.data.base,
                    start: response.data.inicio,
                    end: response.data.final,
                });
            } else {
                setState(defaultState);
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const changeCenter = (center) => {
        var value = {
            ...filter,
            base: center
        };
        setFilter(value);
    }

    const changeSort = async (column, order) => {
        var value = {
            ...filter,
            ordem: column.sortable,
            ordenacao: order,
            pagina: 0,
        };
        setFilter(value);
        await agm.post('/ocorrencias/agenda', { filtro: value }, {}).then((response) => {
            if (!response.data.error) {
                setState({
                    loaded: true,
                    pages: toInteger((response.data.count / filter.registros)) + 1,
                    page: filter.pagina,
                    count: response.data.count,
                    rows: response.data.rows,
                    locations: response.data.posicoes,
                    veicles: response.data.veiculos,
                    base: response.data.base,
                    start: response.data.inicio,
                    end: response.data.final,
                });
            } else {
                setState(defaultState);
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const changeFilter = async (startDateTime, endDateTime, vision, keyword, page, rows, contract, types, cpccpa, categories, technicians) => {
        var value = {
            ...filter,
            pagina: page,
            registros: rows,
            inicio: startDateTime,
            final: endDateTime,
            palavrachave: keyword,
            visao: vision,
            contrato: contract,
            tipos: types,
            cpccpa: cpccpa,
            categorias: categories,
            tecnicos: technicians
        };
        setVision(vision);
        setFilter(value);
        await agm.post('/ocorrencias/agenda', { filtro: value }, {}).then((response) => {
            if (!response.data.error) {
                setState({
                    loaded: true,
                    pages: toInteger((response.data.count / value.registros)) + 1,
                    page: value.pagina,
                    count: response.data.count,
                    rows: response.data.rows,
                    locations: response.data.posicoes,
                    veicles: response.data.veiculos,
                    base: response.data.base,
                    start: response.data.inicio,
                    end: response.data.final
                });
            } else {
                setState(defaultState);
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    useEffect(() => {
        if (!state.loaded) {
            refreshItems();
        }
        return
    }, [filter]);

    const updateVisitValues = async (values) => {
        values.user = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        await agm.post('/ocorrencias/agendamento', values).then((response) => {
            if (!response.data.error) {
                updateAppointments(values, dependencies);
                closeVisitEdition();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const deleteVisit = async (values) => {
        values.user = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        await agm.post('/ocorrencias/desagendamento/' + visit.id, values, {}).then((response) => {
            closeDeletionVisit();
            if (!response.data.error) {

                updateAppointments({ ocorrencia: values.ocorrencia, abertura: values.abertura }, dependencies);
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            closeDeletionVisit();
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const changeDatetime = async (value, values) => {
        values.dataAgenda = value;
        await updateAppointments(values, dependencies);
    }

    const changeSchedule = async (event, values) => {

        if (event.target.name == 'tecnico') {
            values.tecnico = event.target.value;
        }

        if (event.target.name == 'prestadora') {
            values.prestadora = event.target.value;
            values.tecnico = null;
        }
        await updateAppointments(values, dependencies);
    }

    const openDocumentEdition = (item) => {
        setDocument(item);
        setOpenDocumentEditionDialog(true);
    }

    const openInfraEdition = (infra) => {
        agm.get('/unidades/infra/' + infra.id, {}, {}).then((response) => {
            if (!response.data.error) {
                setInfra(response.data);
                setInfoValues(response.data.valores);
                setInfraDocument(null);
                setOpenInfraEditionDialog(true);
            } else {
                setState(defaultState);
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const openEquipmentEdition = (item) => {

    }

    const openVisitEdition = (value) => {
        var visit = {};
        if (value && value.id) {
            visit = {
                id: value.id,
                ocorrencia: item.id,
                dataAgenda: value.dataAgenda,
                tecnico: value.tecnico.id,
                auxiliar: value.AUXILIAR,
                prestadora: value.tecnico.PRESTADORA,
                observacao: value.observacao,
                veiculo: value.veiculo,
                hora: value.hora,
                abertura: item.dateAperture
            };
        } else {
            visit = {
                id: null,
                ocorrencia: item.id,
                dataAgenda: null,
                tecnico: null,
                auxiliar: null,
                prestadora: null,
                observacao: null,
                veiculo: null,
                hora: null,
                abertura: item.dateAperture
            };
        }
        setVisit(visit);
        updateAppointments(visit, dependencies);
        setOpenVisitEditionDialog(true);
    }

    const openDeletionVisit = (visit) => {
        setVisit(visit);
        setMessage({
            title: 'Agendamento Técnico',
            message: 'Deseja excluir o agendamento técnico selecioando ?',
            warn: 'Esta ação irá remover o agendamento técnico e pode deixar a ocorrência com estado inválido.'
        });
        setOpenDeletionVisitDialog(true);
    }

    const closeDeletionVisit = () => {
        setOpenDeletionVisitDialog(false);
    }

    const closeVisitEdition = () => {
        setOpenVisitEditionDialog(false);
    }

    const closeDocumentEdition = () => {
        setOpenDocumentEditionDialog(false);
    }

    const closeDeletionDocument = () => {
        setOpenDeletionDocumentDialog(false);
    }

    const closeInfraEdition = () => {
        setInfra(defaultInfra);
        setOpenInfraEditionDialog(false);
    }

    const changeDocumentInfra = (values) => {
        setInfraDocument(values);
    }

    const openDeletionDocument = (item) => {
        setDocument(item);
        setMessage({
            title: 'Documento',
            message: 'Deseja excluir o documento "' + item.nome + '"?',
            warn: 'Esta ação irá remover o documento do local de armazenamento e o arquivo não poderá mais ser recuperado.'
        });
        setOpenDeletionDocumentDialog(true);
    }

    const fileSize = (bytes) => {
        var exp = Math.log(bytes) / Math.log(1024) | 0;
        var result = (bytes / Math.pow(1024, exp)).toFixed(2);
        return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
    }

    const onUpload = (files) => {
        var selectedFiles = files.map(file => ({
            id: file.name,
            name: file.name,
            readableSize: fileSize(file.size),
            uploaded: false,
            preview: URL.createObjectURL(file),
            file,
            progress: 0,
            error: false,
            url: ""
        }));
        setUploadState(selectedFiles);
        selectedFiles.forEach(processUpload);
    }

    const updateFile = ((id, data) => {
        setUploadState((state) =>
            state.map((file) => (file.id === id ? { ...file, ...data } : file))
        );
    });

    const processUpload = ((uploadedFile) => {
        const data = new FormData();
        data.append('occurrence', item.id);
        data.append('usuario', localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname'));
        data.append('sts', item.companyStatus);
        data.append("file", uploadedFile.file);
        agm.post("/documentos/arquivar", data, {
            occurrence: item.id, usuario: localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname'), sts: item.companyStatus,
            onUploadProgress: (progressEvent) => {
                let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                updateFile(uploadedFile.id, { progress });
            },
        })
            .then((response) => {
                if (!response.data.error) {
                    updateFile(uploadedFile.id, {
                        uploaded: true,
                        id: response.data._id,
                        url: response.data.url,
                    });
                } else {
                    console.error(`Houve um problema ao fazer upload do arquivo ${uploadedFile.name} no servidor`);
                    updateFile(uploadedFile.id, { error: true });
                }
            })
            .catch((err) => {
                console.error(`Houve um problema ao fazer upload do arquivo ${uploadedFile.name} no servidor`);
                updateFile(uploadedFile.id, { error: true });
            });
    });

    const closeUpload = () => {
        setOpenUploadDialog(false);
        updateProcessings(item.id);
    };

    const openUpload = (item) => {
        setItem(item);
        setUploadState(defaultUploadState);
        setOpenUploadDialog(true);
    };

    const updateDocumentValues = async (values) => {
        await agm.put('/documentos/' + values.id, values).then((response) => {
            if (!response.data.error) {
                updateProcessings(values.ocorrencia);
                closeDocumentEdition();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    };

    const updateDocuments = async (values, dependencies) => {
        var { id } = values;
        await agm.post('/ocorrencias/documentos', { ocorrencia: id }, {}).then((response) => {
            if (!response.data.error) {
                dependencies.documents = response.data.documentos;
                setDependencies(dependencies);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const updateDependencies = async (values) => {

    };

    const updateAppointments = async (values, dependencies) => {
        await agm.post('/ocorrencias/agendamentos', values, {}).then((response) => {
            if (!response.data.error) {
                setAppointments({
                    typesTechnician: response.data.prestadoras,
                    technicians: response.data.tecnicos,
                    schedules: response.data.agenda,
                    veicles: response.data.veiculos,
                    resources: []
                });
                dependencies.visits = response.data.agendamentos;
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const updateProcessings = async (id) => {
        await agm.get('/ocorrencias/' + id, {}).then(async (response) => {
            var newItem = {
                loaded: true,
                ocorrencia: response.data.ocorrencia,
                id: response.data.ocorrencia.id,
                company: response.data.ocorrencia.empresa,
                contract: response.data.ocorrencia.contrato,
                dateAperture: response.data.ocorrencia.abertura,
                number: response.data.ocorrencia.numero,
                unit: response.data.ocorrencia.unidade.id,
                code: response.data.ocorrencia.unidade.codigo,
                name: response.data.ocorrencia.unidade.nome,
                supervisor: response.data.ocorrencia.unidade.fiscal,
                controller: (response.data.ocorrencia.unidade.gerenciadora) ? response.data.ocorrencia.unidade.gerenciadora.nome : 'Não Informada',
                engineer: (response.data.ocorrencia.unidade.engenheiro) ? response.data.ocorrencia.unidade.engenheiro.nome : 'Não Informado',
                team: (response.data.ocorrencia.unidade.equipe) ? response.data.ocorrencia.unidade.equipe.nome : 'Não Informada',
                region: (response.data.ocorrencia.unidade.regiao) ? response.data.ocorrencia.unidade.regiao.nome : 'Não Informada',
                typeUnit: response.data.ocorrencia.unidade.tipo.nome,
                conclusionStatus: response.data.ocorrencia.realizado,
                companyStatus: response.data.ocorrencia.STS_EMPRESA,
                occurrenceType: response.data.ocorrencia.TIPO_OCORR,
                category: response.data.ocorrencia.CATEGORIA,
                invoiceType: response.data.ocorrencia.TIPO_NOTA,
                ocorrenceStatus: response.data.ocorrencia.STS_OCORRENCIA,
                atendType: response.data.ocorrencia.TIPO_ATEND,
                statusRevenues: response.data.ocorrencia.statusFaturamento ? response.data.ocorrencia.statusFaturamento.id : null,
                description: response.data.ocorrencia.descricao,
                dateFirstAtend: response.data.ocorrencia.dataLimitePrimeiroAtendimento,
                dateConclusion: response.data.ocorrencia.dataLimiteConclusaoSla,
                dateStarted: response.data.ocorrencia.dataInicioAtendimento,
                datefinished: response.data.ocorrencia.dataConclusaoAtendimento,
                timeService: response.data.ocorrencia.horasExecucaoServico,
                kmService: response.data.ocorrencia.kmExecucaoServico,
                dataAgenda: response.data.ocorrencia.dataPrevistaAtendimento,
                technician: (response.data.ocorrencia.tecnico) ? response.data.ocorrencia.tecnico.id : null,
                auxiliar: (response.data.ocorrencia.auxiliar) ? response.data.ocorrencia.auxiliar.id : null,
                typeTechnician: (response.data.ocorrencia.tecnico) ? response.data.ocorrencia.tecnico.PRESTADORA : null,
                obs: response.data.ocorrencia.obs,
                veicle: response.data.ocorrencia.veiculo,
                hour: response.data.ocorrencia.hora,
                symptom: (response.data.ocorrencia.sintoma) ? response.data.ocorrencia.sintoma.id : null,
                symptomLocal: response.data.ocorrencia.LOC_SINTOMA,
                executed: response.data.ocorrencia.servicoExecutado,
                orderDesc: response.data.ocorrencia.ordemCompra,
                planDesc: response.data.ocorrencia.resumoPlan,
                dateProtocol: response.data.ocorrencia.dataProtocoloEntrega,
                timelimcpa: response.data.ocorrencia.horalimitecpa,
                timelimcpc: response.data.ocorrencia.horalimitecpc,
                numbersa: response.data.ocorrencia.numerosa,
                lote: response.data.ocorrencia.LOTE_FAT,
                task: response.data.ocorrencia.tarefa.id,
                taskName: response.data.ocorrencia.tarefa.nome,
                budgetid: null,
                budgetnumero: null,
                budgetdataCriacao: null,
                budgetdataProtocolo: null,
                budgetdataEnvio: null,
                budgetvalorMaoObra: null,
                budgetvalorMaterial: null,
                budgetvalorDesconto: null,
                budgetvalortotal: null,
                budgetFASE_ORCAMENTO: null,
                budgetORCAMENTISTA: null,
                budgetTECNICO: null,
                budgetOCORRENCIA: null,
                budgetfoiExecutado: null,
                budgetServicoExecutar: null,
                idProduto: '',
                qtdProduto: '',
                codigoProduto: '',
                nomeProduto: '',
                lpuProduto: '',
                custoProduto: '',
                bdiProduto: '',
                valorProduto: '',
                aplicacaoProduto: '',
                origemProduto: '',
                unidadeProduto: '',
                instalacaoProduto: '',
                produto: {},
                atualizarPdf: false,
                baixarEstoque: false,
                chavePdf: null,
                orderCpNome:null,
                orderCpQtd: 1,
                orderCpUnid: null,
                orderCpVlr: 0.0,
                orderCpFornec: null,            
                orderCpInstruc: null,
                orderPlanNome:null,
                orderPlanQtd: 1,
                orderPlanUnid: null,
                orderPlanInstruc: null,            
            };
            var dependencies = {
                loaded: true,
                companies: response.data.dependencias.listaEmpresas,
                contracts: response.data.dependencias.listaContratos,
                occurrenceTypes: response.data.dependencias.listaTiposOcorrencia,
                invoiceTypes: response.data.dependencias.listaTiposNota,
                categories: response.data.dependencias.listaCategorias,
                ocorrenceStatusList: response.data.dependencias.listaStatusOcorrencia,
                atendTypes: response.data.dependencias.listaTiposAtendimento,
                companyStatusList: response.data.dependencias.listaStatusEmpresa,
                symptomes: response.data.dependencias.listaSintomas,
                symptomLocals: response.data.dependencias.listaLocaisSintomas,
                revenuesStatusList: response.data.dependencias.listaStatusFaturamento,
                revenuesLoteList: response.data.dependencias.listaLotesFaturamento,
                conclusionStatusList: response.data.dependencias.listaStatusRealizacao,
                phases: response.data.dependencias.fasesOrcamento,
                makers: response.data.dependencias.orcamentistas,
                tasks: response.data.dependencias.tarefas,
                expensesType: response.data.dependencias.listaTiposDepesas,
                expensesProvider: response.data.dependencias.listaFornecedores,
                technicians: [],
                items: [],
                removes: [],
                documents: [],
                infras: response.data.dependencias.infrasUnidade,
                equipments: response.data.dependencias.equipamentos,
                actions: response.data.dependencias.acoes,
                orders: response.data.dependencias.ordens,
                plans: response.data.dependencias.planos,
                infrasUnidade: [],
                visits: [],
                expenses: [],
                applications: response.data.dependencias.aplicacoes,
                units: response.data.dependencias.unidades,
                origins: response.data.dependencias.origens,
                region: response.data.dependencias.regiao
            };
            visit.ocorrencia = newItem.id;
            visit.abertura = newItem.dateAperture;
            await updateAppointments(visit, dependencies);
            await updateBudgets(newItem, dependencies);
            await updateExpenses(newItem, dependencies);
            await updateDocuments(newItem, dependencies);
            setItem(newItem);
            setDependencies(dependencies);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const updateExpenses = async (values, dependencies) => {
        await agm.post('/ocorrencias/despesas', { ocorrencia: values.id }, {}).then((response) => {
            if (!response.data.error) {
                values.expenseCodigo = '';
                values.expenseNome = '';
                values.expenseTipo = 1;
                values.expenseNota = '';
                values.expenseNotaFornecedor = '';
                values.expenseQtd = '';
                values.expenseCusto = '';
                values.expenseValor = '';
                values.expenseId = '';
                values.expenseTotalCustos = 0.0;
                values.expenseTotalDespesas = 0.0;
                values.produto = {};
                dependencies.expenses = response.data.despesas;
                dependencies.expenses.forEach(expense => {
                    values.expenseTotalCustos = values.expenseTotalCustos + (expense.custo * expense.qtd);
                    values.expenseTotalDespesas = values.expenseTotalDespesas + (expense.valor * expense.qtd);
                });
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const updateBudgets = async (values, dependencies) => {
        await agm.post('/ocorrencias/orcamentos', { ocorrencia: values.id }, {}).then((response) => {
            if (!response.data.error) {
                if (response.data.orcamentos.length > 0) {
                    var budget = response.data.orcamentos[0];
                    values.budgetid = budget.id;
                    values.budgetnumero = budget.numero;
                    values.budgetdataCriacao = budget.dataCriacao;
                    values.budgetdataProtocolo = budget.dataProtocolo;
                    values.budgetdataEnvio = budget.dataEnvio;
                    values.budgetvalorMaoObra = budget.valorMaoObra;
                    values.budgetvalorMaterial = budget.valorMaterial;
                    values.budgetvalorDesconto = budget.valorDesconto;
                    values.budgetvalortotal = (parseFloat(values.budgetvalorMaoObra) + parseFloat(values.budgetvalorMaterial) - parseFloat(values.budgetvalorDesconto));
                    values.budgetFASE_ORCAMENTO = budget.FASE_ORCAMENTO;
                    values.budgetORCAMENTISTA = budget.ORCAMENTISTA;
                    values.budgetTECNICO = budget.TECNICO;
                    values.budgetOCORRENCIA = budget.OCORRENCIA;
                    values.budgetfoiExecutado = budget.foiExecutado;
                    values.budgetServicoExecutar = budget.servicoExecutar;
                    values.idProduto = '';
                    values.qtdProduto = '';
                    values.codigoProduto = '';
                    values.nomeProduto = '';
                    values.lpuProduto = '';
                    values.custoProduto = '';
                    values.bdiProduto = '';
                    values.valorProduto = '';
                    values.origemProduto = '';
                    values.aplicacaoProduto = '';
                    values.unidadeProduto = '';
                    values.instalacaoProduto = '';
                    values.produto = {};
                    values.atualizarPdf = false;
                    values.baixarEstoque = false;
                    values.chavePdf = budget.chavePdf;
                    dependencies.items = budget.itens;
                }
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    }

    const deleteDocument = async (values) => {
        var usuario = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
        await agm.delete('/documentos/' + values.id, { data: { usuario: usuario } }).then((response) => {
            if (!response.data.error) {
                updateProcessings(item.id);
                closeDeletionDocument();
            }
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: error.message });
            setOpenAlert(true);
        })
    };

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const closePrint = () => {
        setOpenPrintDialog(false);
    }

    const generateOTs = async (item, selecteds, genzip) => {
        var data = moment().format('DD-MM-YYYY-HH-mm-ss');
        var filename = 'Formularios_oats_.pdf';
        if (genzip)
            filename = 'Formularios_oats_' + data + '.zip';

        await agm.post('/ocorrencias/agenda/oats', { item: item, selecteds: selecteds, filename: filename, genzip }, (selecteds.length > 0 && genzip ? { responseType: 'blob' } : {})).then(async (response) => {
            if (!response.data.error) {
                try {
                    closePrint();
                    if (genzip) {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        const downloadUrl = URL.createObjectURL(blob);
                        const link = window.document.createElement('a');
                        link.setAttribute('download', filename);
                        link.href = downloadUrl;
                        window.document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(downloadUrl);
                    } else {
                        setMessage(response.data);
                        setOpenAlert(true);
                        const link = window.document.createElement('a');
                        var url = process.env.REACT_APP_AGM_ENDPPOINT + '/reports/' + filename;
                        link.setAttribute('download', filename);
                        link.setAttribute('target', '_target');
                        link.href = url;
                        window.document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                    }
                } catch (error) {
                    setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo. ' + error.message });
                    setOpenAlert(true);
                }
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo. ' + error.message });
            setOpenAlert(true);
        });
    }

    const openPrint = (item) => {
        setSelecteds([]);
        setItem(item);
        setOpenPrintDialog(true);
    }

    const printItem = async (item) => {
        var filename = 'Agenda_Tecnico.pdf';
        await agm.post('/ocorrencias/agenda/lista', { item: item, filename: filename }, {}).then(async (response) => {
            if (!response.data.error) {
                try {
                    closePrint();
                    setMessage(response.data);
                    setOpenAlert(true);
                    const link = window.document.createElement('a');
                    var url = process.env.REACT_APP_AGM_ENDPPOINT + '/reports/' + filename;
                    link.setAttribute('download', filename);
                    link.setAttribute('target', '_target');
                    link.href = url;
                    window.document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo.', detail: error.message });
                    setOpenAlert(true);
                }
            } else {
                setMessage(response.data);
                setOpenAlert(true);
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo.', detail: error.message });
            setOpenAlert(true);
        });
    }

    const openMapaRota = (item) => {
        setItem(item);
        setOpenMapaRotaDialog(true);
    }

    return (
        <Page
            className={classes.root}
            title="Agendas"
        >

            <Container maxWidth={false}>

                <Toolbar
                    icon={AiOutlineSchedule}
                    item={defaultItemNewItem}
                    resultset={state}
                    resultModes={resultModes}
                    vision={vision}
                    visions={defaultVisions}
                    selectedMode={selectedMode}
                    openCreation={openCreation}
                    changeFilter={changeFilter}
                    changeCenter={changeCenter}
                />

                <Confirmations item={document}
                    message={message}
                    open={openDeletionDocumentDialog}
                    close={closeDeletionDocument}
                    confirmation={deleteDocument} />

                <Confirmations item={visit}
                    message={message}
                    open={openDeletionVisitDialog}
                    close={closeDeletionVisit}
                    confirmation={deleteVisit} />

                <Document item={document}
                    openEdition={openDocumentEdition}
                    closeEdition={closeDocumentEdition}
                    updateValues={updateDocumentValues}
                    open={openDocumentEditionDialog}
                    statusList={state.statusList}
                />

                <Schedule item={visit}
                    openEdition={openVisitEdition}
                    closeEdition={closeVisitEdition}
                    updateValues={updateVisitValues}
                    open={openVisitEditionDialog}
                    changeDatetime={changeDatetime}
                    changeSchedule={changeSchedule}
                    appointments={appointments}
                    selectedMode={selectedMode}
                />

                <Upload item={item}
                    uploadState={uploadState}
                    onUpload={onUpload}
                    close={closeUpload}
                    open={openUploadDialog}
                    destinationTitle={"Enviar Documentos para Ocorrência"} />

                <Alerts message={message}
                    open={openAlert}
                    closeAlert={closeAlert} />

                <Confirmations item={item}
                    message={message}
                    open={openDeletionDialog}
                    close={closeDeletion}
                    confirmation={deleteValues} />

                <Confirmations item={action}
                    message={message}
                    open={openDeletionActionDialog}
                    close={closeDeletionAction}
                    confirmation={deleteAction} />

                <Treatment item={item}
                    icon={RiAlarmWarningFill}
                    open={openTreatmentDialog}
                    closeTreatment={closeTreatment}
                    statusHistory={statusHistory}
                    statusRegister={defaultStatusRegister}
                    updateTreatmentValues={updateTreatmentValues} />

                <Occurrence item={item}
                    selectedMode={selectedMode}
                    open={openEditionDialog}
                    closeEdition={closeEdition}
                    updateValues={updateValues}
                    dependencies={dependencies}
                    appointments={appointments}
                    openUpload={openUpload}
                    openDocumentEdition={openDocumentEdition}
                    updateDocuments={updateDocuments}
                    openDeletionDocument={openDeletionDocument}
                    openVisitEdition={openVisitEdition}
                    openDeletionVisit={openDeletionVisit}
                    updateAppointments={updateAppointments}
                    updateBudgets={updateBudgets}
                    updateExpenses={updateExpenses}
                    slas={[]}
                    openInfraEdition={openInfraEdition}
                    openInfraCreation={() => { }}
                    openEquipmentEdition={openEquipmentEdition}
                    openActionEdition={openActionEdition}
                    openDeletionAction={openDeletionAction}
                    updateProcessings={updateProcessings}
                    createOAT={createOAT}
                />

                <Create item={item}
                    open={openCreationDialog}
                    closeCreation={closeCreation}
                    createValues={createValues}
                    dependencies={dependencies}
                    updateDependencies={updateDependencies}
                />

                <Infra item={infra}
                    open={openInfraEditionDialog}
                    closeEdition={closeInfraEdition}
                    updateValues={() => { }}
                    dependencies={dependencies}
                    openUpload={() => { }}
                    openDocumentEdition={() => { }}
                    updateDependencies={() => { }}
                    selectedMode={selectedMode}
                    infraDocument={infraDocument}
                    changeDocumentInfra={changeDocumentInfra}
                    openDeletion={() => { }}
                    infoValues={infoValues}
                    changeItem={(value, index, type) => { }}
                />

                <Print item={item}
                    open={openPrintDialog}
                    closePrint={closePrint}
                    generateOTs={generateOTs}
                    selecteds={selecteds}>
                </Print>

                <Action
                    item={action}
                    open={openActionEditionDialog}
                    closeEdition={closeActionEdition}
                    updateValues={updateActionValues}
                />

                <MapaRota item={item}
                    open={openMapaRotaDialog}
                    closeEdition={closeMapaRota}
                    changeCenter={changeCenter}
                    openEdition={openEdition}
                    resultset={state}
                    data={filter.inicio} />


                <Box mt={3}>
                    <Card>
                        <CardContent>

                            <Results
                                resultSet={state}
                                resultModes={resultModes}
                                icon={AiOutlineSchedule}
                                vision={vision}
                                selectedMode={selectedMode}
                                openEdition={openEdition}
                                openDeletion={openDeletion}
                                openTreatment={openTreatment}
                                openExportDialog={openExportDialog}
                                changeSort={changeSort}
                                dependencies={dependencies}
                                openPrint={openPrint}
                                printItem={printItem}
                                openMapaRota={openMapaRota}
                            />

                        </CardContent>
                    </Card>
                </Box>
            </Container>
        </Page>
    );
};

export default Agendas;
